$(function () {
  "use strict";
  const anchors = document.querySelectorAll('a[href^="#"]');
  const header = document.getElementById('SiteHeader').offsetHeight;
  for (let i = 0; i < anchors.length; i++) {
    anchors[i].addEventListener('click', (e) => {
      e.preventDefault();
      const href = anchors[i].getAttribute("href");
      const target = document.getElementById(href.replace('#', ''));
      const position = window.pageYOffset + target.getBoundingClientRect().top - header;
      window.scroll({
        top: position,
        behavior: 'smooth'
      });
    });
  }

  $('.detailbox dt').on('click', function () {
    $(this).next('dd').slideToggle(300);
    $(this).toggleClass('open');
  });  
});